import type { ReactNode } from 'react';

export const symbol_simulation: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M423.5-463.5Q400-487 400-520t23.5-56.5Q447-600 480-600t56.5 23.5Q560-553 560-520t-23.5 56.5Q513-440 480-440t-56.5-23.5ZM100-605v344q11 19 38.5 33t65.5 22v-363q-32-7-58-16t-46-20Zm760 0q-20 11-46 20t-58 16v363q38-8 65-22t39-33v-344ZM40-261v-424q0-57 111.5-86T480-800q217 0 328.5 29T920-685v424q0 42-44 72t-129 47q-20 5-35.5-9T696-185v-391q0-19 12-33t30-18q46-10 79.5-23t54.5-30q-49-31-145-46t-247-15q-147 0-243 14.5T86-680q19 17 52.5 29.5T222-627q18 4 30 18t12 33v391q0 20-15.5 33.5T213-142q-85-17-129-47t-44-72Zm60-344v399-399Zm760 0v399-399ZM480-400q72 0 116 26.5t44 70.5q0 10-6.5 16.5T617-280H343q-10 0-16.5-6.5T320-303q0-44 44-70.5T480-400Z"
		/>
	</svg>
);
